import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'client' | 'partner' | 'agency';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = React.memo(
  ({ children, requiredRole }) => {
    const { isAuthenticated, user, isLoading } = useAuth();
    const location = useLocation();

    // Show loading while authentication is being checked
    if (isLoading && !isAuthenticated) {
      // Determine spinner color based on route or required role
      const isPartnerRoute = requiredRole === 'partner' || location.pathname.startsWith('/partner');
      const spinnerColor = isPartnerRoute ? 'border-partner' : 'border-primary';

      return (
        <div className="flex items-center justify-center h-screen">
          <div
            className={`animate-spin rounded-full size-12 md:size-32 border-b-2 ${spinnerColor}`}
          ></div>
        </div>
      );
    }

    // If not authenticated, redirect to login
    if (!isAuthenticated) {
      const loginPath = requiredRole === 'partner' ? '/partner/sign-in' : '/client/sign-in';
      return <Navigate to={loginPath} state={{ from: location }} replace />;
    }

    // Check role if required
    // if (requiredRole && user?.type !== requiredRole) {
    //   const loginPath = requiredRole === 'client' || requiredRole === 'agency' ? '/client/sign-in' : '/partner/sign-in';
    //   return <Navigate to={loginPath} state={{ from: location }} replace />;;
    // }

    return <>{children}</>;
  }
);

ProtectedRoute.displayName = 'ProtectedRoute';
